import { OAUTH_API } from '@/services/Configuration'
import Axios from 'axios'

import { getAddresses } from './'

import { error } from '@/services/Log'

export const deleteAddress = async ({ data, email }) => {
    try {
        const response = (await Axios.delete(`${OAUTH_API}/sf/customer/address/`, { data })).data;
        if (response?.success) {
            const addresses = await getAddresses({ email });
            return { success: true, savedAddresses: addresses };
        } else {
            error('Error occurred in deleteAddress function:', response?.message);
            return { success: false }
        }
    } catch (e) {
        error('Error occurred in deleteAddress function:', e)
        return { success: false }
    }
}
